import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import InsightImg1 from '@/assets/generations-in-the-wild/insight-img-1.png';
import InsightImg2 from '@/assets/generations-in-the-wild/insight-img-2.png';
import InsightImg3 from '@/assets/generations-in-the-wild/insight-img-3.png';
import InsightImg4 from '@/assets/generations-in-the-wild/insight-img-4.png';
import InsightImg5 from '@/assets/generations-in-the-wild/insight-img-5.png';

export const OutdoorsInsights = () => {
  const intl = useIntl();
  const insights = [
    {
      title: intl.formatMessage({
        defaultMessage:
          'Families who get into the outdoors together strengthen bonds and lowered stress',
        id: 'bTDbUi',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'The top benefits families report from their RV travels? Stronger family bonds (40%) and lowered stress (19%). Another key benefit includes the opportunity to teach children leadership (17%).',
        id: 'rGpXWw',
      }),
      image: InsightImg1,
    },
    {
      title: intl.formatMessage({
        defaultMessage: 'Whole-family planning fuels better experiences for everyone',
        id: 'HQ6SKr',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'For better trip outcomes, let the kids help. Of the nearly one third of families who involve their children in planning trips, meals, or activities, they report greater relaxation (81%) and more help from their children during the trip (70%).',
        id: 'mkMhn5',
      }),
      image: InsightImg2,
    },
    {
      title: intl.formatMessage({
        defaultMessage: 'Millennial families disconnect to reconnect with each other and nature',
        id: 'vkJsKP',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Seven out of 10 millennial families report that their trips are a valuable time to disconnect from technology, with 90% saying they value RV trips as an opportunity to connect with their family.',
        id: 'INffUQ',
      }),
      image: InsightImg3,
    },
    {
      title: intl.formatMessage({
        defaultMessage: 'Time spent in nature increases spiritual connectedness for teens',
        id: 'ZGasZn',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'The majority of teens in RVing families (88%) feel spiritually connected with many engaging in prayer (59%), reflection (34%), and reporting that they take time to read sacred texts (21%) during family RV trips.',
        id: 'ICsGbW',
      }),
      image: InsightImg4,
    },
    {
      title: intl.formatMessage({
        defaultMessage: 'Budget-conscious GenZ seeks affordability on the road',
        id: 'jfB2Wk',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'GenZ RVers tend to travel most frequently, with the majority (65%) saying they plan to take at least five trips this year. Perhaps because of the frequency of travel they also prefer to stay closest to home, with an average trip distance that’s 100 miles less than that of older generations.',
        id: 'd8ORle',
      }),
      image: InsightImg5,
    },
  ];
  return (
    <div className="text-center section-spacing !max-w-60">
      <Heading variant={EHeadingStyleVariant.H1}>
        <FormattedMessage defaultMessage="What we discovered" id="y5i1qy" />
      </Heading>
      <Text variant={ETextStyleVariant.LargeBold} className="mt-4 text-secondary-base">
        <FormattedMessage
          defaultMessage="Among many interesting findings some surprising insights caught our attention - collectively they speak to the unique value time spent outdoors brings families of all ages, especially in light of the cultural pressures of work and the digital distractions that challenge family connection."
          id="WH46Gs"
        />
      </Text>

      {insights.map(({ image, title, description }, idx) => (
        <div
          key={`insight-${idx + 1}`}
          className={`flex flex-col-reverse gap-4 items-center md:my-16 my-12 ${
            idx % 2 ? 'md:flex-row-reverse' : 'md:flex-row'
          } `}>
          <div className="relative flex-1 w-full">
            <Image
              src={image}
              alt={`insight-image-${idx + 1}`}
              sizes="100vw"
              width={500}
              height={280}
            />
          </div>

          <div className={`flex-1 text-left ${idx % 2 ? 'md:text-right' : 'md:text-left'}`}>
            <Heading variant={EHeadingStyleVariant.H5} className={idx % 2 ? 'md:mr-8' : 'md:ml-8'}>
              {title}
            </Heading>
            <Text
              variant={ETextStyleVariant.MediumBold}
              className={`mt-2 md:mt-4 text-secondary-base ${idx % 2 ? 'md:mr-8' : 'md:ml-8'}`}>
              {description}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};
